import { PATHS } from '@belong/common';
import { PageRedirectToBelongNext } from 'page-redirect-to-belong-next/PageRedirectToBelongNext';
import { PropertyPagePicker } from 'pages/Accounts/Pages/YourPortfolio/Properties/property-page-picker';
import ToursAndApps from './ToursAndApps/ToursAndApps';
import Lease from './YourHome/Leases/Lease/Lease';
import Leases from './YourHome/Leases/Leases';
import { ResidentMaintenance } from './YourHome/Maintenance/resident-maintenance';
import Rent from './YourHome/Rent/Rent';
import Earnings from './YourPortfolio/Earnings/Earnings';
import PortfolioMaintenance from './YourPortfolio/Maintenance/Maintenance';
import { SellHome } from './YourPortfolio/SellHome/SellHome';

// The `component` casts below are there because `declaration` is on in the
// shared tsconfig: these components' inferred types name a class or a props
// type their own module keeps private, which declaration emit cannot write
// down (TS9006). The casts are erased; see the followups doc.
export const PAGES_CONFIG = {
  ACTION_ITEMS: {
    path: '/accounts/portfolio/action-items',
    component: PageRedirectToBelongNext,
  },
  PORTFOLIO_PROPERTIES: {
    path: '/accounts/portfolio/properties',
    exact: true,
    component: PageRedirectToBelongNext,
  },
  PORTFOLIO_PROPERTIES_PROPERTY: {
    path: `/accounts/portfolio/properties/:propertyId/:unitId?`,
    exact: true,
    component: PropertyPagePicker,
  },
  PORTFOLIO_MAINTENANCE: {
    path: `${PATHS.HOMEOWNER_ACCOUNT_MAINTENANCE}/:maintenanceId?`,
    component: /** @type {import('react').ComponentType<any>} */ (
      PortfolioMaintenance
    ),
  },
  EARNINGS: {
    path: PATHS.HOMEOWNER_ACCOUNT_EARNINGS,
    component: Earnings,
  },
  PORTFOLIO_DOCUMENTS: {
    path: '/accounts/portfolio/documents',
    component: PageRedirectToBelongNext,
  },
  SELL_HOME: {
    path: PATHS.HOMEOWNER_ACCOUNT_SELL,
    component: SellHome,
  },
  YOUR_HOME: {
    path: PATHS.RESIDENTS_ACCOUNT_PROPERTIES,
    exact: true,
    component: /** @type {import('react').ComponentType<any>} */ (Leases),
  },
  YOUR_HOME_LEASE: {
    path: `${PATHS.RESIDENTS_ACCOUNT_PROPERTIES}/:unitId/:leaseId`,
    component: Lease,
  },
  YOUR_HOME_MAINTENANCE: {
    path: `${PATHS.RESIDENTS_ACCOUNT_MAINTENANCE}/:maintenanceId?`,
    component: ResidentMaintenance,
  },
  PAYMENTS: {
    path: `${PATHS.RESIDENTS_ACCOUNT_PAYMENTS}/:billId?`,
    component: /** @type {import('react').ComponentType<any>} */ (Rent),
  },
  PAYMENTS_MEMBER: {
    path: PATHS.ACCOUNTS_PAYMENTS,
    component: /** @type {import('react').ComponentType<any>} */ (Rent),
  },
  YOUR_HOME_DOCUMENTS: {
    path: PATHS.RESIDENTS_ACCOUNT_DOCUMENTS,
    component: PageRedirectToBelongNext,
  },
  TOURS_AND_APPS: {
    path: PATHS.RESIDENTS_ACCOUNT_TOURS_AND_APPS,
    component: ToursAndApps,
  },
  RESIDENT_INBOX: {
    path: '/accounts/inbox',
    component: PageRedirectToBelongNext,
  },
  FAVORITES: {
    path: '/accounts/favorites',
    component: PageRedirectToBelongNext,
  },
  PROFILE: {
    path: '/accounts/profile',
    component: PageRedirectToBelongNext,
  },
  REFERRAL: {
    path: '/accounts/referral',
    component: PageRedirectToBelongNext,
  },
  REFERRER_PAYMENTS: {
    path: '/accounts/referrer/payments',
    component: PageRedirectToBelongNext,
  },
  INBOX: {
    path: '/accounts/portfolio/inbox',
    component: PageRedirectToBelongNext,
  },
  INSURANCE: {
    path: PATHS.HOMEOWNER_ACCOUNT_INSURANCE_SUMMARY,
    component: PageRedirectToBelongNext,
  },
  WEALTH: {
    path: PATHS.HOMEOWNER_ACCOUNT_WEALTH,
    component: PageRedirectToBelongNext,
  },
  WEALTH_FLOW: {
    path: PATHS.HOMEOWNER_ACCOUNT_WEALTH_ANALYSIS_FLOW,
    component: PageRedirectToBelongNext,
  },
  LISTING_PERFORMANCE: {
    path: PATHS.HOMEOWNER_ACCOUNT_LISTING_PERFORMANCE,
    component: PageRedirectToBelongNext,
  },
};

export const HOMEOWNER_PAGES = [
  PAGES_CONFIG.ACTION_ITEMS,
  PAGES_CONFIG.PORTFOLIO_PROPERTIES,
  PAGES_CONFIG.PORTFOLIO_PROPERTIES_PROPERTY,
  PAGES_CONFIG.PORTFOLIO_MAINTENANCE,
  PAGES_CONFIG.EARNINGS,
  PAGES_CONFIG.PORTFOLIO_DOCUMENTS,
  PAGES_CONFIG.SELL_HOME,
  PAGES_CONFIG.WEALTH,
  PAGES_CONFIG.WEALTH_FLOW,
  PAGES_CONFIG.INSURANCE,
  PAGES_CONFIG.LISTING_PERFORMANCE,
  PAGES_CONFIG.INBOX,
];

export const PAGES = [
  PAGES_CONFIG.TOURS_AND_APPS,
  PAGES_CONFIG.FAVORITES,
  PAGES_CONFIG.PAYMENTS_MEMBER,
  PAGES_CONFIG.PROFILE,
  PAGES_CONFIG.REFERRAL,
  PAGES_CONFIG.REFERRER_PAYMENTS,
  PAGES_CONFIG.RESIDENT_INBOX,
];

export const RENTER_ACCOUNT_PAGES = [
  PAGES_CONFIG.YOUR_HOME,
  PAGES_CONFIG.YOUR_HOME_LEASE,
  PAGES_CONFIG.YOUR_HOME_MAINTENANCE,
  PAGES_CONFIG.PAYMENTS,
  PAGES_CONFIG.YOUR_HOME_DOCUMENTS,
];
